<template>
  <el-container class="form-body">
    <el-main class='form-login-body'>
      <el-form key="d" :model="ruleForm" :rules="rules" ref="ruleForm" @keyup.enter.native="loginClick">
        <!--账号框-->
        <el-form-item prop="phone" class="login-meta">
          <div class="wrap-input">
            <el-input :placeholder="`请输入${placeholdString()}`" v-model="ruleForm.phone">
              <div slot="prepend">
                <div class="input-icon-up">
                  <img src="../../../../assets/user.png" alt="" />
                </div>
              </div>
            </el-input>
          </div>
        </el-form-item>
        <!--切换手机、邮箱验证码-->
        <el-form-item v-if="supportPhone && supportEmail">
          <div class="code-radio-group">
            <el-radio v-model="currentSendType" label="1" class="code-radio-item" @change="sendTypeChanged">手机验证码
            </el-radio>
            <el-radio v-model="currentSendType" label="2" class="code-radio-item" @change="sendTypeChanged">邮箱验证码
            </el-radio>
          </div>
        </el-form-item>
        <el-form-item prop="code" class="login-meta login-meta-before-code">
          <div class="wrap-input">
            <el-input :placeholder="`请输入${codeString()}`" maxlength="6" v-model="ruleForm.code">
              <div slot="prepend">
                <div class="input-icon-up">
                  <img src="../../../../assets/pass.png" alt="" />
                </div>
              </div>
              <div slot="append">
                <div v-show="sendCodeEnable" @click="getCode" class="code-btn">
                  获取{{ codeString() }}
                </div>
                <div v-show="!sendCodeEnable" class="code-count-down">{{ codeText }}</div>
              </div>
            </el-input>
          </div>
        </el-form-item>
        <!--提示语-->
        <div class="code-label">
          <div v-if="sendError.length > 0" class="code-label-error">{{ sendError }}</div>
          <div v-else-if="sendResult.length > 0" class="code-label-tips">验证码已发送至{{ sendResult }}</div>
        </div>
        <!--App登录按钮-->
        <el-form-item v-if='!isCollapse' class="form-bottom">
          <el-button size="large" type="primary" class="login-button" @click.stop.prevent="loginClick">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-main>
    <!--Web登录按钮-->
    <el-footer v-if='isCollapse' class='form-login-footer' style="height: 78px !important; padding-top: 26px !important;">
      <el-button type="primary" @click="loginClick" class="login-btn">
        登录
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import 'vant/lib/index.css';
import { verifyWebCode } from '@/api/api.p'
import * as LoginType from "@/pages/m/views/login/loginType";
import { validateEmail, validateMobile } from '@/libs/util'

export default {
  name: 'login-by-code',
  props: {
    isCollapse: {
      type: Boolean,
      value: false,
    },
    accountPlaceholder: {
      type: String,
      value: '',
    },
    supportTypeList: {
      type: Array,
      value: [],
    }
  },
  data () {
    const validateAccount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(`请输入${this.placeholdString()}`));
        // callback(new Error(this.accountPlaceholder));
      } else if (this.currentSendType === '1') {
        if (validateMobile(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的手机号'));
        }
      } else if (this.currentSendType === '2') {
        if (validateEmail(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的邮箱'));
        }
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value === '' && this.sendError.length === 0) {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    return {
      supportPhone: false,
      supportEmail: false,
      supportPwd: false,
      currentSendType: null,
      codeText: '',
      sendCodeEnable: true,
      sendResult: "",
      sendError: "",
      timer: null,
      ruleForm: {
        phone: '',
        code: '',
      },
      rules: {
        phone: [
          { required: true, validator: validateAccount, trigger: 'blur' },
        ],
        code: [
          { required: true, validator: validateCode, trigger: 'blur' }
        ],
      },
    }
  },
  watch: {
    supportTypeList () {
      this.supportTypeListChanged();
    }
  },
  mounted () {
    this.supportTypeListChanged();
  },
  methods: {
    supportTypeListChanged () {
      this.supportPhone = this.supportTypeList.includes(LoginType.LOGIN_TYPE_PHONE_CODE);
      this.supportEmail = this.supportTypeList.includes(LoginType.LOGIN_TYPE_EMAIL_CODE);
      this.supportPwd = LoginType.checkPwdEnable(this.supportTypeList);
      if (this.supportPhone) {
        this.currentSendType = '1';
      } else if (this.supportEmail) {
        this.currentSendType = '2';
      } else {
        this.currentSendType = null;
      }
    },
    sendTypeChanged (e) {
      console.log('sendTypeChanged: e = ', e);
      this.sendError = "";
      this.sendResult = "";
      this.$refs['ruleForm'].resetFields();
    },
    placeholdString () {
      return this.currentSendType === '2' ? '邮箱' : '手机号';
      // return this.currentSendType === '2' ? '邮箱验证码' : '手机验证码';
    },
    codeString () {
      return this.currentSendType === '2' ? '邮箱验证码' : '手机验证码';
    },
    /*获取验证码接口*/
    async getCode () {
      if (this.ruleForm.phone === '') {
        this.$toast(`请先输入${this.placeholdString()}`);
        return;
      }
      if (this.currentSendType === '1' && !validateMobile(this.ruleForm.phone)) {
        this.$toast(`请输入正确的手机号`);
        return;
      } else if (this.currentSendType === '2' && !validateEmail(this.ruleForm.phone)) {
        this.$toast(`请输入正确的邮箱`);
        return;
      }
      if (this.currentSendType === null) {
        this.$toast('登录方式不正确，请确认。');
        return;
      }
      if (!this.sendCodeEnable) {
        return;
      }
      let param = {
        loginName: this.ruleForm.phone,
        sendType: this.currentSendType,
      }
      this.sendResult = "";
      this.sendError = "";
      this.sendCodeEnable = false;
      this.codeText = `获取${this.codeString()}`;
      const res = await verifyWebCode(param, {
        headers: {
          'kywebInfo': 'channel/unify,osName/web,appName/%e5%bf%ab%e5%ba%94%e5%ae%a2%e7%bd%91%e7%ab%99,appVersion/111,appBuildNumber/xxx,appId/xxx'
        }
      });
      if (res && res.meta) {
        if (res.meta.code === 0) {
          if (res.data && res.data.length > 0) {
            this.sendResult = res.data;
            this.countDown(59)
          } else {
            this.sendCodeEnable = true;
            this.$toast('发送失败');
          }
        } else {
          this.sendCodeEnable = true;
          this.sendError = res.meta.message;
        }
      } else {
        this.sendCodeEnable = true;
        this.$toast('发送失败');
      }
    },
    // 倒计时方法
    countDown (time) {
      if (time === 0) {
        this.sendCodeEnable = true;
        return
      } else {
        this.sendCodeEnable = false;
        this.codeText = '重新获取' + time + '秒';
        time--;
      }
      this.timer = setTimeout(() => {
        this.countDown(time)
      }, 1000)
    },
    /*登录接口*/
    async loginClick () {
      if (this.currentSendType === null) {
        this.$toast('登录方式不正确，请确认。');
        return;
      }
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          await this.didLogin();
        } else {
          return false;
        }
      });
    },
    async didLogin () {
      let param = {
        "agree": "1",
        "loginCode": this.ruleForm.code,
        "loginName": this.ruleForm.phone,
        "loginType": '3',
      }
      this.$emit('login', param);
    },
  }
}
</script>